import _slicedToArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _toConsumableArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { Connector, __privateAdd, __privateGet, __privateSet, __publicField } from "./chunk-5NCTPR6C.js"; // src/injected.ts

import { AddChainError, ChainNotConfiguredError, ConnectorNotFoundError, ProviderRpcError, ResourceUnavailableError, SwitchChainError, UserRejectedRequestError, getClient, normalizeChainId } from "@wagmi/core";
import { providers } from "ethers";
import { getAddress, hexValue } from "ethers/lib/utils.js"; // src/utils/getInjectedName.ts

function getInjectedName(ethereum) {
  var _ethereum$providers, _getName;

  if (!ethereum) return "Injected";

  var getName = function getName(provider) {
    if (provider.isApexWallet) return "Apex Wallet";
    if (provider.isAvalanche) return "Core Wallet";
    if (provider.isBackpack) return "Backpack";
    if (provider.isBifrost) return "Bifrost Wallet";
    if (provider.isBitKeep) return "BitKeep";
    if (provider.isBitski) return "Bitski";
    if (provider.isBraveWallet) return "Brave Wallet";
    if (provider.isCoinbaseWallet) return "Coinbase Wallet";
    if (provider.isDawn) return "Dawn Wallet";
    if (provider.isExodus) return "Exodus";
    if (provider.isFrame) return "Frame";
    if (provider.isFrontier) return "Frontier Wallet";
    if (provider.isGamestop) return "GameStop Wallet";
    if (provider.isHyperPay) return "HyperPay Wallet";
    if (provider.isImToken) return "ImToken";
    if (provider.isKuCoinWallet) return "KuCoin Wallet";
    if (provider.isMathWallet) return "MathWallet";
    if (provider.isOkxWallet || provider.isOKExWallet) return "OKX Wallet";
    if (provider.isOneInchIOSWallet || provider.isOneInchAndroidWallet) return "1inch Wallet";
    if (provider.isOpera) return "Opera";
    if (provider.isPhantom) return "Phantom";
    if (provider.isPortal) return "Ripio Portal";
    if (provider.isRabby) return "Rabby";
    if (provider.isRainbow) return "Rainbow";
    if (provider.isStatus) return "Status";
    if (provider.isTally) return "Taho";
    if (provider.isTokenPocket) return "TokenPocket";
    if (provider.isTokenary) return "Tokenary";
    if (provider.isTrust || provider.isTrustWallet) return "Trust Wallet";
    if (provider.isXDEFI) return "XDEFI Wallet";
    if (provider.isZerion) return "Zerion";
    if (provider.isMetaMask) return "MetaMask";
  };

  if ((_ethereum$providers = ethereum.providers) === null || _ethereum$providers === void 0 ? void 0 : _ethereum$providers.length) {
    var _names$;

    var nameSet = /* @__PURE__ */new Set();
    var unknownCount = 1;

    var _iterator = _createForOfIteratorHelper(ethereum.providers),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var provider = _step.value;
        var name = getName(provider);

        if (!name) {
          name = "Unknown Wallet #".concat(unknownCount);
          unknownCount += 1;
        }

        nameSet.add(name);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var names = _toConsumableArray(nameSet);

    if (names.length) return names;
    return (_names$ = names[0]) !== null && _names$ !== void 0 ? _names$ : "Injected";
  }

  return (_getName = getName(ethereum)) !== null && _getName !== void 0 ? _getName : "Injected";
} // src/injected.ts


var _provider;

var InjectedConnector = /*#__PURE__*/function (_Connector) {
  _inherits(InjectedConnector, _Connector);

  var _super = _createSuper(InjectedConnector);

  function InjectedConnector() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        chains = _ref.chains,
        options_ = _ref.options;

    _classCallCheck(this, InjectedConnector);

    var options = _objectSpread({
      shimDisconnect: true,
      getProvider: function getProvider() {
        return typeof window !== "undefined" ? window.ethereum : void 0;
      }
    }, options_);

    _this = _super.call(this, {
      chains: chains,
      options: options
    });

    __publicField(_assertThisInitialized(_this), "id", "injected");

    __publicField(_assertThisInitialized(_this), "name");

    __publicField(_assertThisInitialized(_this), "ready");

    __privateAdd(_assertThisInitialized(_this), _provider, void 0);

    __publicField(_assertThisInitialized(_this), "shimDisconnectKey", "".concat(_this.id, ".shimDisconnect"));

    __publicField(_assertThisInitialized(_this), "onAccountsChanged", function (accounts) {
      if (accounts.length === 0) _this.emit("disconnect");else _this.emit("change", {
        account: getAddress(accounts[0])
      });
    });

    __publicField(_assertThisInitialized(_this), "onChainChanged", function (chainId) {
      var id = normalizeChainId(chainId);

      var unsupported = _this.isChainUnsupported(id);

      _this.emit("change", {
        chain: {
          id: id,
          unsupported: unsupported
        }
      });
    });

    __publicField(_assertThisInitialized(_this), "onDisconnect", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(error) {
        var _getClient$storage;

        var _provider2, isAuthorized;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(error.code === 1013)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 3;
                return _this.getProvider();

              case 3:
                _provider2 = _context.sent;

                if (!_provider2) {
                  _context.next = 10;
                  break;
                }

                _context.next = 7;
                return _this.getAccount();

              case 7:
                isAuthorized = _context.sent;

                if (!isAuthorized) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                _this.emit("disconnect");

                if (_this.options.shimDisconnect) (_getClient$storage = getClient().storage) === null || _getClient$storage === void 0 ? void 0 : _getClient$storage.removeItem(_this.shimDisconnectKey);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    var provider = options.getProvider();
    if (typeof options.name === "string") _this.name = options.name;else if (provider) {
      var detectedName = getInjectedName(provider);
      if (options.name) _this.name = options.name(detectedName);else {
        if (typeof detectedName === "string") _this.name = detectedName;else _this.name = detectedName[0];
      }
    } else _this.name = "Injected";
    _this.ready = !!provider;
    return _this;
  }

  _createClass(InjectedConnector, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _ref3,
            chainId,
            _getClient$storage2,
            provider,
            accounts,
            account,
            id,
            unsupported,
            chain,
            _args2 = arguments;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref3 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, chainId = _ref3.chainId;
                _context2.prev = 1;
                _context2.next = 4;
                return this.getProvider();

              case 4:
                provider = _context2.sent;

                if (provider) {
                  _context2.next = 7;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 7:
                if (provider.on) {
                  provider.on("accountsChanged", this.onAccountsChanged);
                  provider.on("chainChanged", this.onChainChanged);
                  provider.on("disconnect", this.onDisconnect);
                }

                this.emit("message", {
                  type: "connecting"
                });
                _context2.next = 11;
                return provider.request({
                  method: "eth_requestAccounts"
                });

              case 11:
                accounts = _context2.sent;
                account = getAddress(accounts[0]);
                _context2.next = 15;
                return this.getChainId();

              case 15:
                id = _context2.sent;
                unsupported = this.isChainUnsupported(id);

                if (!(chainId && id !== chainId)) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 20;
                return this.switchChain(chainId);

              case 20:
                chain = _context2.sent;
                id = chain.id;
                unsupported = this.isChainUnsupported(id);

              case 23:
                if (this.options.shimDisconnect) (_getClient$storage2 = getClient().storage) === null || _getClient$storage2 === void 0 ? void 0 : _getClient$storage2.setItem(this.shimDisconnectKey, true);
                return _context2.abrupt("return", {
                  account: account,
                  chain: {
                    id: id,
                    unsupported: unsupported
                  },
                  provider: provider
                });

              case 27:
                _context2.prev = 27;
                _context2.t0 = _context2["catch"](1);

                if (!this.isUserRejectedRequestError(_context2.t0)) {
                  _context2.next = 31;
                  break;
                }

                throw new UserRejectedRequestError(_context2.t0);

              case 31:
                if (!(_context2.t0.code === -32002)) {
                  _context2.next = 33;
                  break;
                }

                throw new ResourceUnavailableError(_context2.t0);

              case 33:
                throw _context2.t0;

              case 34:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 27]]);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _getClient$storage3;

        var provider;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getProvider();

              case 2:
                provider = _context3.sent;

                if (provider === null || provider === void 0 ? void 0 : provider.removeListener) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                provider.removeListener("accountsChanged", this.onAccountsChanged);
                provider.removeListener("chainChanged", this.onChainChanged);
                provider.removeListener("disconnect", this.onDisconnect);
                if (this.options.shimDisconnect) (_getClient$storage3 = getClient().storage) === null || _getClient$storage3 === void 0 ? void 0 : _getClient$storage3.removeItem(this.shimDisconnectKey);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "getAccount",
    value: function () {
      var _getAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var provider, accounts;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getProvider();

              case 2:
                provider = _context4.sent;

                if (provider) {
                  _context4.next = 5;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 5:
                _context4.next = 7;
                return provider.request({
                  method: "eth_accounts"
                });

              case 7:
                accounts = _context4.sent;
                return _context4.abrupt("return", getAddress(accounts[0]));

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getAccount() {
        return _getAccount.apply(this, arguments);
      }

      return getAccount;
    }()
  }, {
    key: "getChainId",
    value: function () {
      var _getChainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var provider;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.getProvider();

              case 2:
                provider = _context5.sent;

                if (provider) {
                  _context5.next = 5;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 5:
                return _context5.abrupt("return", provider.request({
                  method: "eth_chainId"
                }).then(normalizeChainId));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getChainId() {
        return _getChainId.apply(this, arguments);
      }

      return getChainId;
    }()
  }, {
    key: "getProvider",
    value: function () {
      var _getProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var provider;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                provider = this.options.getProvider();
                if (provider) __privateSet(this, _provider, provider);
                return _context6.abrupt("return", __privateGet(this, _provider));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getProvider() {
        return _getProvider.apply(this, arguments);
      }

      return getProvider;
    }()
  }, {
    key: "getSigner",
    value: function () {
      var _getSigner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _ref4,
            chainId,
            _yield$Promise$all,
            _yield$Promise$all2,
            provider,
            account,
            _args7 = arguments;

        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _ref4 = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {}, chainId = _ref4.chainId;
                _context7.next = 3;
                return Promise.all([this.getProvider(), this.getAccount()]);

              case 3:
                _yield$Promise$all = _context7.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                provider = _yield$Promise$all2[0];
                account = _yield$Promise$all2[1];
                return _context7.abrupt("return", new providers.Web3Provider(provider, chainId).getSigner(account));

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getSigner() {
        return _getSigner.apply(this, arguments);
      }

      return getSigner;
    }()
  }, {
    key: "isAuthorized",
    value: function () {
      var _isAuthorized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _getClient$storage4, provider, account;

        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                if (!(this.options.shimDisconnect && !((_getClient$storage4 = getClient().storage) === null || _getClient$storage4 === void 0 ? void 0 : _getClient$storage4.getItem(this.shimDisconnectKey)))) {
                  _context8.next = 3;
                  break;
                }

                return _context8.abrupt("return", false);

              case 3:
                _context8.next = 5;
                return this.getProvider();

              case 5:
                provider = _context8.sent;

                if (provider) {
                  _context8.next = 8;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 8:
                _context8.next = 10;
                return this.getAccount();

              case 10:
                account = _context8.sent;
                return _context8.abrupt("return", !!account);

              case 14:
                _context8.prev = 14;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", false);

              case 17:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 14]]);
      }));

      function isAuthorized() {
        return _isAuthorized.apply(this, arguments);
      }

      return isAuthorized;
    }()
  }, {
    key: "switchChain",
    value: function () {
      var _switchChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(chainId) {
        var _this2 = this;

        var provider, id, _this$chains$find, _error$data, _error$data$originalE, chain, _chain$rpcUrls$public, _chain$rpcUrls$public2, currentChainId;

        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.getProvider();

              case 2:
                provider = _context9.sent;

                if (provider) {
                  _context9.next = 5;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 5:
                id = hexValue(chainId);
                _context9.prev = 6;
                _context9.next = 9;
                return Promise.all([provider.request({
                  method: "wallet_switchEthereumChain",
                  params: [{
                    chainId: id
                  }]
                }), new Promise(function (res) {
                  return _this2.on("change", function (_ref5) {
                    var chain = _ref5.chain;
                    if ((chain === null || chain === void 0 ? void 0 : chain.id) === chainId) res();
                  });
                })]);

              case 9:
                return _context9.abrupt("return", (_this$chains$find = this.chains.find(function (x) {
                  return x.id === chainId;
                })) !== null && _this$chains$find !== void 0 ? _this$chains$find : {
                  id: chainId,
                  name: "Chain ".concat(id),
                  network: "".concat(id),
                  nativeCurrency: {
                    name: "Ether",
                    decimals: 18,
                    symbol: "ETH"
                  },
                  rpcUrls: {
                    default: {
                      http: [""]
                    },
                    public: {
                      http: [""]
                    }
                  }
                });

              case 12:
                _context9.prev = 12;
                _context9.t0 = _context9["catch"](6);
                chain = this.chains.find(function (x) {
                  return x.id === chainId;
                });

                if (chain) {
                  _context9.next = 17;
                  break;
                }

                throw new ChainNotConfiguredError({
                  chainId: chainId,
                  connectorId: this.id
                });

              case 17:
                if (!(_context9.t0.code === 4902 || (_context9.t0 === null || _context9.t0 === void 0 ? void 0 : (_error$data = _context9.t0.data) === null || _error$data === void 0 ? void 0 : (_error$data$originalE = _error$data.originalError) === null || _error$data$originalE === void 0 ? void 0 : _error$data$originalE.code) === 4902)) {
                  _context9.next = 34;
                  break;
                }

                _context9.prev = 18;
                _context9.next = 21;
                return provider.request({
                  method: "wallet_addEthereumChain",
                  params: [{
                    chainId: id,
                    chainName: chain.name,
                    nativeCurrency: chain.nativeCurrency,
                    rpcUrls: [(_chain$rpcUrls$public = (_chain$rpcUrls$public2 = chain.rpcUrls.public) === null || _chain$rpcUrls$public2 === void 0 ? void 0 : _chain$rpcUrls$public2.http[0]) !== null && _chain$rpcUrls$public !== void 0 ? _chain$rpcUrls$public : ""],
                    blockExplorerUrls: this.getBlockExplorerUrls(chain)
                  }]
                });

              case 21:
                _context9.next = 23;
                return this.getChainId();

              case 23:
                currentChainId = _context9.sent;

                if (!(currentChainId !== chainId)) {
                  _context9.next = 26;
                  break;
                }

                throw new ProviderRpcError("User rejected switch after adding network.", {
                  code: 4001
                });

              case 26:
                return _context9.abrupt("return", chain);

              case 29:
                _context9.prev = 29;
                _context9.t1 = _context9["catch"](18);

                if (!this.isUserRejectedRequestError(_context9.t1)) {
                  _context9.next = 33;
                  break;
                }

                throw new UserRejectedRequestError(_context9.t1);

              case 33:
                throw new AddChainError();

              case 34:
                if (!this.isUserRejectedRequestError(_context9.t0)) {
                  _context9.next = 36;
                  break;
                }

                throw new UserRejectedRequestError(_context9.t0);

              case 36:
                throw new SwitchChainError(_context9.t0);

              case 37:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[6, 12], [18, 29]]);
      }));

      function switchChain(_x2) {
        return _switchChain.apply(this, arguments);
      }

      return switchChain;
    }()
  }, {
    key: "watchAsset",
    value: function () {
      var _watchAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(_ref6) {
        var address, _ref6$decimals, decimals, image, symbol, provider;

        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                address = _ref6.address, _ref6$decimals = _ref6.decimals, decimals = _ref6$decimals === void 0 ? 18 : _ref6$decimals, image = _ref6.image, symbol = _ref6.symbol;
                _context10.next = 3;
                return this.getProvider();

              case 3:
                provider = _context10.sent;

                if (provider) {
                  _context10.next = 6;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 6:
                return _context10.abrupt("return", provider.request({
                  method: "wallet_watchAsset",
                  params: {
                    type: "ERC20",
                    options: {
                      address: address,
                      decimals: decimals,
                      image: image,
                      symbol: symbol
                    }
                  }
                }));

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function watchAsset(_x3) {
        return _watchAsset.apply(this, arguments);
      }

      return watchAsset;
    }()
  }, {
    key: "isUserRejectedRequestError",
    value: function isUserRejectedRequestError(error) {
      return error.code === 4001;
    }
  }]);

  return InjectedConnector;
}(Connector);

_provider = new WeakMap();
export { InjectedConnector };